var _path, _g, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetsResultMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 140,
    viewBox: "0 0 200 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_216_313",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 9,
    width: 78,
    height: 88
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119 9L157.105 31V75L119 97L80.8949 75V31L119 9Z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_216_313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119 9L157.105 31V75L119 97L80.8949 75V31L119 9Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M119 -35L157.105 -13V31L119 53L80.8949 31V-13L119 -35Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_216_313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68 48L106.105 70V114L68 136L29.8949 114V70L68 48Z",
    fill: "#97A3B7"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_216_313",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 48,
    width: 78,
    height: 88
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48L106.105 70V114L68 136L29.8949 114V70L68 48Z",
    fill: "#97A3B7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_216_313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68 48L106.105 70V114L68 136L29.8949 114V70L68 48Z",
    fill: "#97A3B7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_216_313)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.3906,
    y: 92,
    width: 80,
    height: 60,
    fill: "#E3E6EB"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_216_313)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 23,
    width: 80,
    height: 60,
    fill: "#E3E6EB"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8984 86.2866L44.7267 87.9197L44.727 94.4515L41.8987 92.8185L41.8984 86.2866Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9189 93.2273L56.7472 94.8603L56.7474 101.392L53.9191 99.7591L53.9189 93.2273Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7276 107.515L41.8994 105.882L41.8995 109.148L44.7278 110.781L44.7276 107.515L53.9195 112.823L53.9196 116.088L56.7479 117.721L56.7478 114.455L53.9195 112.823L53.9195 109.557L44.7275 104.249L44.7276 107.515Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.348 23.4792C106.188 25.9904 106.535 29.3829 109.395 31.5604C112.66 34.0461 117.963 34.007 121.24 31.4731C124.516 28.9392 124.526 24.8699 121.261 22.3841C118.401 20.2066 113.977 19.9666 110.721 21.6439L115.923 25.6047L113.55 27.4399L108.348 23.4792Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.865 33.0087L129.83 39.8346L132.203 37.9994L123.238 31.1735C122.917 31.521 122.554 31.8531 122.149 32.1657C121.745 32.4784 121.315 32.7594 120.865 33.0087ZM119.662 32.0932C120.123 31.8557 120.561 31.5798 120.967 31.2655C121.373 30.9513 121.73 30.6134 122.035 30.2579L122.035 30.2579C121.73 30.6134 121.373 30.9513 120.967 31.2655C120.561 31.5798 120.123 31.8557 119.662 32.0931L119.662 32.0932Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144 70L168.249 112H119.751L144 70Z",
    fill: "white",
    stroke: "#181818"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144 100L144 82",
    stroke: "#181818"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M144 105H144.004V105.004H144V105Z",
    stroke: "#181818",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_216_313",
    x: 23.8949,
    y: 42,
    width: 88.2102,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_216_313"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_216_313",
    x: -3.60938,
    y: 42,
    width: 180,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_216_313"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_216_313",
    x: -50,
    y: -27,
    width: 180,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_216_313"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsResultMaintenance);
export default __webpack_public_path__ + "static/media/assets-result-maintenance.4e1bad0ea16060d0f6bbe6c1b39a7e8f.svg";
export { ForwardRef as ReactComponent };